<dl>
    <div class="approval-status-row" role="status" aria-live="polite" aria-atomic="true">
        <dt
            appLocalizationPopupDirective
            localizationCode="ApprovalStatus"
            class="label"
            id="approval-status-label">
            {{ 'ApprovalStatus' | translate: {Default: "Approval Status"} }}
        </dt>
        <dd class="value" [attr.aria-labelledby]="'approval-status-label'">
            <mat-chip-set
                *ngIf="buySellPlanEmployee"
                [attr.aria-label]="'ApprovalStatus' | translate: {Default: 'Approval Status'}">
                <mat-chip
                    [ngClass]="getStatusChipClass()"
                    [attr.aria-label]="('ApprovalStatus' | translate: {Default: 'Approval Status'}) + ': ' + buySellPlanEmployee.status?.name">
                    {{ buySellPlanEmployee.status?.name }}
                </mat-chip>
            </mat-chip-set>
        </dd>
    </div>
</dl>